module.exports = __webpack_public_path__ + "static/WTP3-30a29e183664f5c4c1095ba7a9d7a8b8.jpg";